import { BtnConfigSearchProduct } from "../../../../components/common/BtnConfigSearchProduct/BtnConfigSearchProduct";
import { useUiTranslator } from "../../../../hooks/useUiTranslator";
import { SaveConfigurationButton } from "../ConfigurationControls/SaveConfigurationButton";

import { JSX } from "react";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import { IndividualControlLayoutProps } from "@plansoft-configuration-renderer/components";
import { useSessionId } from "@plansoft-configuration-renderer/framework";
import { useSearch } from "@tanstack/react-router";
import { useNavigate } from "@tanstack/react-router";

import { DisclaimerApplicationConfigurator } from "./variants/DisclaimerApplicationConfigurator";
import { PrintPreview } from "./variants/PrintPreview";
import { UtilsApplication } from "./variants/UtilsApplication";
import { UtilsProductView } from "./variants/UtilsProductView";
import { UtilsScrollTop } from "./variants/UtilsScrollTop";

export function IndividualComponent(
  props: IndividualControlLayoutProps,
): JSX.Element {
  const { variant = "variantFallback", custom = {} } = props;
  const t = useUiTranslator();
  const sessionId = useSessionId();
  const { configurationId } = useSearch({
    strict: false,
  });
  const navigate = useNavigate();

  const handleExitConfiguration = (): void => {
    navigate({
      to: "/",
    });
  };

  let componentBody;
  switch (variant) {
    case "printPreview_ProductView":
      componentBody = <PrintPreview />;
      break;
    case "utils_ProductView":
      componentBody = <UtilsProductView />;
      break;
    case "utils_Professional":
      componentBody = <></>;
      break;
    case "utils_Application":
      componentBody = <UtilsApplication />;
      break;

    case "utils_ProfessionalSearch":
      componentBody = (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <BtnConfigSearchProduct
            sessionId={sessionId}
            path="/XAS_SELECTION/0"
          />
        </Box>
      );
      break;
    case "utils_ApplicationSearch":
      componentBody = (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <BtnConfigSearchProduct sessionId={sessionId} path="/" />
        </Box>
      );
      break;
    case "utils_AddProjectList": {
      componentBody = (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <SaveConfigurationButton
            configurationId={configurationId}
            label={t(
              "CustomApp:buttons.AddToProjectList",
              "Add to project list",
            )}
            fullWidth
            navigationCallback={handleExitConfiguration}
          />
        </Box>
      );
      break;
    }
    case "utils_DisclaimerApplicationConfigurator": {
      componentBody = (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <DisclaimerApplicationConfigurator />
        </Box>
      );
      break;
    }
    case "utils_ScrollTop":
      return <UtilsScrollTop />;
    default:
      componentBody = (
        <Alert>
          <AlertTitle>{variant}</AlertTitle>
          <code>{JSON.stringify(custom, null, 2)}</code>
        </Alert>
      );
      break;
  }

  return <Box my={2}>{componentBody}</Box>;
}
